<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-book">
<h1>About the Book</h1>
<p>In the year 1879, William and Jane Burns from Durham, England, migrated to Newcastle, Australia, in the hope of finding a better life for themselves and their two children, Joseph, aged three, and Elizabeth, aged one. Stormy seas, interspersed with weeks of boredom, made their three-month-long voyage on the sailing ship, William Stonehouse, anything but pleasant. William, like his father, was a coal miner and found work easily in a Newcastle colliery. During this time, he befriended a German immigrant, Wilhelm Zschachner, and learned that a new coal discovery had been made in the state of Tasmania. The thought of moving to Tasmania was challenging to the Burns family now that they had two additional children. Nevertheless, they repacked their furniture and treasures brought out with them from England and moved to remote Bruny Island, off Tasmania’s southeast coast.</p>
<p>Here, they were true pioneers. Between working the new coal mine, William and his still-increasing family cleared a parcel of land on Coal Point and built themselves a cosy home from axe-split palings. Sadly, William died young after a rock fall at the mine, forcing Jane to become a midwife in order to keep the family together until they reached adulthood and married. Joyce – the ‘Bruny Island Girl’ – was born in 1899 to Louisa, one of Jane’s daughters, and this book tells the story of her remarkable life on the island before marrying Cecil Cutcliffe. Max Cutcliffe is one of their sons and the author of this book.</p>
<div class="pagebreak"></div>
<p>‘Bruny Island’, as it is known today, was originally written as ‘Bruni Island’, named after the early navigator Bruni D’Entrecasteaux. ‘Bruni Island’ became ‘Bruny Island’ after the name was anglicised prior to 1920. In the early dialogue of this book, the local residents refer to the island as ‘Bruni’, the only known spelling of the word at that time.</p>
<div class="pagebreak"></div>
<div class="figure">
<img alt="C:\Users\Editioral\Pictures\fp\1.jpg" src="media/file0.jpg" style="width:4.78125in;height:5.09375in"/>
<p class="caption">C:\Users\Editioral\Pictures\fp\1.jpg</p>
</div>
<p><strong><br/>
</strong></p>
<div class="pagebreak"></div>
<p class="textcenter"><img alt="2" src="media/file1.jpg" style="width:4.78401in;height:7.18657in"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?3b8a0355